"use client";
import dynamic from 'next/dynamic';

const DynamicImage = dynamic(() => import("next/image"), { ssr: false });

const SectionPartnersLayout2 = () => {
  return (
    <section className="pb-16 pt-6">
      <div className="container relative">
        <div className="flex flex-wrap justify-center">
          <DynamicImage
            src="/partners/p1.webp"
            alt="partner 1"
            width={173}
            height={103}
            className="m-2 md:mx-8 md:my-5"
            loading="lazy"
          />
          <DynamicImage
            src="/partners/p2.webp"
            alt="partner 2"
            width={173}
            height={103}
            className="m-2 md:mx-8 md:my-5"
            loading="lazy"
          />
          <DynamicImage
            src="/partners/p3.webp"
            alt="partner 3"
            width={173}
            height={103}
            className="m-2 md:mx-8 md:my-5"
            loading="lazy"
          />
          <DynamicImage
            src="/partners/p4.webp"
            alt="partner 4"
            width={173}
            height={103}
            className="m-2 md:mx-8 md:my-5"
            loading="lazy"
          />
          <DynamicImage
            src="/partners/p5.webp"
            alt="partner 5"
            width={173}
            height={103}
            className="m-2 md:mx-8 md:my-5"
            loading="lazy"
          />
        </div>
      </div>
    </section>
  );
};

export default SectionPartnersLayout2;
